import { Fragment, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import { Link, useSearchParams } from "react-router-dom";
import Footer from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";
import "./payResultStyle.css";

export default function Failed() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [message] = useState(() => searchParams.get("message"));

  useEffect(() => {
    setSearchParams(cur => {
      cur.delete("message");
      return { ...cur };
    });
  }, []);

  return (
    <Fragment>
      <Menu />

      <main
        className="container flex-grow-1 rtl-all d-flex flex-column align-items-center justify-content-center mt-0"
        style={{ minHeight: "60dvh" }}
      >
        <div className="d-flex flex-column align-items-center justify-content-center col-12 col-sm-8 col-xl-6">
          <div className="border border-secondary rounded-circle d-flex align-items-center justify-content-center">
            <X color="red" size={60} />
          </div>

          <h1 className="mt-2 text-danger">عملیات با خطا مواجه شد</h1>
          <p>خطایی در انجام عملیات درخواستی رخ داد</p>

          {message && (
            <Alert variant="danger" className="w-100 my-3">
              {message}
            </Alert>
          )}
        </div>

        <div className="d-flex align-items-center justify-content-center mt-3">
          <Link to="/" className="btn btn-success-style text-center mx-1">
            صفحه اصلی
          </Link>
        </div>
      </main>

      <Footer />
    </Fragment>
  );
}
